/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 12/2/20
 * Time: 11:45 AM
 */
import React from 'react';
import './CaptureVisitor.scss';
import {Col, Row} from "reactstrap";
import {Icon} from "semantic-ui-react";
import {Tooltip} from "antd";
// import $ from 'jquery';

const App = (props) => {
  // $('#uiaurZUo').addEventListener('mouseover', function(){
  //  console.log("abc")
  // })
  // $('#uiaurZUo').addEventListener('mouseout', function(){
  //   console.log("abcdd")
  // })

  let visitorObj = props.error_code === 710 ? props.visitor.visitor : props.visitor;
  return (
    <Row className={"capture-visitor-wrapper"} key={`${props.index}${new Date().getTime()}`}>
      <Col xs={1} className={"none-padding cv-no"}>
        {`${props.index < 9 ? `0${props.index+1}`: `${props.index+1}`}.`}
      </Col>

      {visitorObj.photoPath ? <Col xs={2} className={"none-padding cv-visitor-img"}>
        <img src={visitorObj.photoPath} alt={"visitor-img"} id={"uiaurZUo"}
             // onMouseOver={()=>props.visitorImageMouseHover(visitorObj.photoPath)}
             // onMouseOut={()=>props.visitorImageMouseHover("123")}
             onMouseOver={()=> props.visitorImageMouseHover(visitorObj.photoPath)}
             onMouseOut={()=> props.visitorImageMouseOut(null)}
        />
      </Col>:null}

      <Col className={"none-padding cv-visitor-info"}>
        <p className={"cv-first-p"}>{`${visitorObj.title ? `${visitorObj.title}. ` : ``} ${visitorObj.firstName ? visitorObj.firstName : ``} ${visitorObj.lastName?visitorObj.lastName:``}`}</p>
        <p className={"cv-second-p"}>{`${visitorObj.identificationValue ? `${visitorObj.identificationValue}` : `-`}`}</p>
      </Col>

      <Col xs={2} className={`none-padding ${props.hideRemoveBtn ? `hide-remove-btn`:``} wrapper-content-1`}>
        <Tooltip placement="topLeft" title="Select visitor">
          <div className={"cv-select-visitor"} onClick={props.selectVisitorHandler}>
            <Icon name='user plus'/>
          </div>
        </Tooltip>
      </Col>
      {!props.hideRemoveBtn ? <Col xs={2} className={"none-padding wrapper-content-2"}>
        <Tooltip placement="topLeft" title="Remove visitor">
          <div className={"cv-rmv-visitor"} onClick={props.removeVisitor}>
            <Icon name='trash alternate'/>
          </div>
        </Tooltip>
      </Col>:null }
      {/*{*/}
        {/*props.error_code === 710 ?*/}
          {/*<Col className={"none-padding cv-visitor-info"} xs={12}>*/}
            {/*<p className={"cv-third-p"}>{`${props.message ? `${props.message}` : `-`}`}</p>*/}
          {/*</Col>:null*/}
      {/*}*/}
    </Row>
  );
};
export default App;
